import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import { TeamMemberTypeRoleEnum } from '@/graphql';

import { MenuConfigs, RolesMenuProps } from './types';

const WIDTH = 110;

const menuConfigs: Partial<MenuConfigs> = {
  [TeamMemberTypeRoleEnum.TeamAdmin]: {
    title: 'Admin',
    description: 'Can manage members within the team',
  },
  [TeamMemberTypeRoleEnum.TeamMember]: {
    title: 'Member',
    description: 'Can create and edit models',
  },
};

function RolesMenu({ value, label, onChange, loading = false }: RolesMenuProps) {
  return (
    <Stack width={WIDTH}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        fullWidth
        data-cy="select-team-member-role"
        size="medium"
        value={value}
        IconComponent={ChevronDownIcon}
        onChange={onChange}
        displayEmpty
        renderValue={(role) => {
          if (loading) return <Skeleton width={45} />;

          if (!role)
            return (
              <Typography variant="body1" color="text.disabled" lineHeight="inherit">
                Select team member role
              </Typography>
            );

          return (
            <Typography variant="body1" color="text.default" lineHeight="inherit">
              {menuConfigs[role].title}
            </Typography>
          );
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        }}
      >
        <Typography variant="h6" color="text.subtle" sx={{ p: 1 }}>
          Select a team member role
        </Typography>
        {Object.entries(menuConfigs).map(([role, config]) => (
          <MenuItem data-cy={`role-option-${role.toLowerCase()}`} key={role} value={role}>
            <Box sx={{ maxWidth: 250, whiteSpace: 'normal' }}>
              <Typography variant="h5">{config.title}</Typography>
              <Typography color="text.muted" variant="body2">
                {config.description}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
}

export default RolesMenu;
